import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description: string;
  action?: ReactNode;
}

export default function PageHeader({ eyebrow, title, description, action }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      spacing={2}
      sx={{ mb: 3, width: '100%', minWidth: 0 }}
    >
      <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
        {eyebrow ? (
          <Typography variant="overline" color="primary.main" sx={{ letterSpacing: 1.4 }}>
            {eyebrow}
          </Typography>
        ) : null}
        <Typography variant="h4" sx={{ mb: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 760, overflowWrap: 'anywhere' }}>
          {description}
        </Typography>
      </Box>

      {action}
    </Stack>
  );
}